import { IApplicationState } from '../../types/redux';

export const selectPage = (state: IApplicationState) => state.page;
